import { OurTeam } from "../queries/aboutUsQuery";
import TeamMemberCard from "./teamMemberCard";

export function OurTeamSection({ ourTeam }: { ourTeam: OurTeam }) {
  return (
    <>
      <div className="families-colorway text-center">
        <span className="text-overline-2">OUR TEAM</span>
      </div>
      <div className="text-center  font-rebrand text-heading-38 text-black md:text-heading-45">
        <strong>
          <em>{ourTeam.title}</em>
        </strong>
      </div>
      <div className="text-body-1 m-auto pt-4 text-center md:w-4/5 lg:w-3/5">
        {ourTeam.subTitle}
      </div>

      <div className="grid grid-cols-1 justify-center gap-1 py-8 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5">
        {ourTeam.teamMembers?.map((member, index) => (
          <TeamMemberCard key={index} member={member} />
        ))}
      </div>
    </>
  );
}

export default OurTeamSection;
